import CenterWiseReportTypes from './center-wise-report.type';

export const getCenterWiseReportDetailsStart = (getData: any) => ({
    type: CenterWiseReportTypes.GET_CENTER_WISE_REPORT_START,
    payload: getData,
});

export const getCenterWiseReportDetailsSuccess = (successData: any) => ({
    type: CenterWiseReportTypes.GET_CENTER_WISE_REPORT_SUCCESS,
    payload: successData,
});

export const getCenterWiseReportDetailsFailure = (failureData: any) => ({
    type: CenterWiseReportTypes.GET_CENTER_WISE_REPORT_FAILURE,
    payload: failureData,
});

export const getCenterWiseReportDetailsResponseResetStart = () => ({
    type: CenterWiseReportTypes.GET_CENTER_WISE_REPORT_RESPONSE_RESET,
});
